import { apiSlice } from '../api-slice';
import {
  ExpenseCategoryResponseSchema, //   ExpenseCategoryResponseSchema,
  ExpenseResponseSchema,
} from './expense.schema';

// import { setCustomerSlice } from './customer-slice';
// import {
//   ResponseCustomerListSchema,
//   ResponseSingleCustomerSchema,
//   SingleCustomer,
// } from './customer.schema';

export const expenseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: (searchParams) => {
        return {
          url: `expense`,
          method: 'GET',
          params: searchParams,
        };
      },
      transformResponse: (response) => {
        return ExpenseResponseSchema.parse(response);
      },
      keepUnusedDataFor: 600,
      providesTags: ['Expense'],
    }),

    createExpense: builder.mutation({
      query: (data) => ({
        url: 'expense',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Expense'],
    }),

    updateExpense: builder.mutation({
      query: (data) => ({
        url: `expense/${data.id}`,
        method: 'PUT',
        body: {
          amount: data.amount,
          description: data.description,
          category_id: data.category_id,
        },
      }),
      invalidatesTags: ['Expense'],
    }),

    deleteExpense: builder.mutation({
      query: (id) => ({
        url: `expense/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Expense'],
    }),

    getExpenseCategories: builder.query({
      query: (searchParams) => {
        return {
          url: `expense/categories`,
          method: 'GET',
          params: searchParams,
        };
      },
      transformResponse: (response) => {
        return ExpenseCategoryResponseSchema.parse(response);
      },
      keepUnusedDataFor: 600,
      providesTags: ['Expense-Category'],
    }),

    createExpenseCategory: builder.mutation({
      query: (data) => ({
        url: 'expense/category',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Expense-Category'],
    }),

    updateExpenseCategory: builder.mutation({
      query: (data) => ({
        url: `expense/category/${data.id}`,
        method: 'PUT',
        body: {
          name: data.name,
        },
      }),
      invalidatesTags: ['Expense-Category'],
    }),

    deleteExpenseCategory: builder.mutation({
      query: (id) => ({
        url: `expense/category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Expense-Category'],
    }),
  }),
});

export const {
  useGetExpensesQuery,
  useCreateExpenseMutation,
  useGetExpenseCategoriesQuery,
  useCreateExpenseCategoryMutation,
  useUpdateExpenseMutation,
  useDeleteExpenseMutation,
  useDeleteExpenseCategoryMutation,
  useUpdateExpenseCategoryMutation,
} = expenseApi;
